import Vue from 'vue';
import api from './data.services';
import store from '../store';

function getCentrosDeCusto(params) {
  let filter = `business_logic.centro_de_custo.id_empresa=${store.state.user.info.id_empresa} `;
  if (params.hasOwnProperty('filter') && params.filter) {
    params.filter = filter + params.filter;
  } else {
    params.filter = filter;
  }
  return api.search('common/list/centro_de_custo', params);
}

// Funções de get genéricas
function getCommon(model, params) {
  return api.search(`common/list/${model}`, params);
}
function getEntity(model, params) {
  return api.search(`entity/${model}`, params);
}
function alterarSenha(params) {
  return api.post('api/common/usuario/alterarSenha', params);
}
function postGeneric(url, params) {
  return api.post(`api/${url}`, params);
}
function alterarEmpresa(params) {
  return api.post('api/common/session/changeEmpresa', params);
}
function getLocalidades(params) {
  return api.search('common/list/localidade', params);
}
function getSecoes(params) {
  return api.search('common/list/secao', params);
}
function getRotas(params) {
  return api.search('common/list/rota', params);
}

function getTipoMetodoPagamentos(params) {
  return api.search('common/list/tipo_metodo_pagamento', params);
}

function getLogins(params) {
  return api.search('entity/usuario', params);
}

function getCircular(params) {
  return api.search('entity/circular', params);
}
function getEstabelecimentos(params) {
  let filter = `business_logic.estabelecimento.id_empresa=${store.state.user.info.id_empresa} and business_logic.estabelecimento.excluido=false `;
  if (params.hasOwnProperty('filter') && params.filter) {
    params.filter = filter + params.filter;
  } else {
    params.filter = filter;
  }
  return api.search('common/list/estabelecimento', params);
}

function getGestores(params) {
  return api.search('entity/usuario_gestor', params);
}

function getUsuariosSite(params) {
  return api.search('common/list/usuario', params);
}

// Principal > Bilhetes
function getBilhetes(params) {
  return api.search('entity/bilhete', params);
}

function fetchGetBilhetes(params) {
  return api.searchFetch('business/bilhete/listar', params);
}

function getStatusBilhetes(params) {
  return api.search('common/list/status_bilhete', params);
}

function getBilhetesCancelados(params) {
  return api.search('entity/bilhete_cancelado', params);
}

function getBilhetesPremiados(params, pago = false) {
  let model = 'pagamento_premio';

  if (pago) {
    model = 'pagamento_premio_pago';
  }

  return api.search(`entity/${model}`, params);
}

function getEventosBilhetes(params, showLoader) {
  return api.search('entity/evento_bilhete', params, showLoader);
}

function getDetalheTransacaoSlot(params) {
  return api.search('common/list/detalhe_transacao_slot', params);
}

function getCanalDeVenda(params) {
  return api.search('common/list/canal_de_venda', params);
}
function cancelarBilhete(idBilhete, params) {
  return api.post(`api/business/bilhete/cancelar/${idBilhete}`, params);
}
function procValidarBilhetePendente(params) {
  return api.post('api/proc/business_logic/atn_manager__validar_bilhete_pendente', params);
}
function revalidarBilhete(idBilhete, params) {
  return api.post(`api/business/bilhete/revalidar/${idBilhete}`, params);
}

function cancelarDeposito(idTransacao, params) {
  return api.post(`api/business/deposito/cancelar/${idTransacao}`, params);
}

function registrarPausa(params) {
  return api.post(`api/business/usuario/registrarPausa`, params);
}

// Principal > Permissões
function getPermissaoUsuario(params) {
  return api.search('common/list/perfil_usuario', params);
}

// Monitor
// Monitor > Sistemas
function getLogs(params) {
  return api.search('entity/log', params);
}

// relatórios

function getColetaArrecadador(params) {
  return api.post('api/proc/report/coleta_arrecadador_v2', params);
}

//Função para verificar apurado_por_localidade_v3
function getApuradoLocalidade(params) {
  return api.post('api/proc/report/apurado_por_localidade_v3', params);
}

// Função para executar procedures
function getReport(locale, procedure, params) {
  // Empresa
  if ('in_id_empresa' in params && !params.in_id_empresa) {
    params.in_id_empresa = store.state.user.info.id_empresa;
  }

  if ('in_ids_empresa' in params && !params.in_ids_empresa) {
    params.in_ids_empresa = store.state.user.info.id_empresa;
  }

  if ('in_id_empresas' in params && !params.in_id_empresas) {
    params.in_id_empresas = store.state.user.info.id_empresa;
  }

  // Localidade (novos e antigos padrões)
  if ('in_id_localidade' in params && !params.in_id_localidade) {
    params.in_id_localidade = store.state.user.info.localidades !== '' ? store.state.user.info.localidades : null;
  }

  if ('in_id_localidades' in params && !params.in_id_localidades) {
    params.in_id_localidades = store.state.user.info.localidades != '' ? store.state.user.info.localidades : null;
  }

  if ('in_ids_localidade' in params && !params.in_ids_localidade) {
    params.in_ids_localidade = store.state.user.info.localidades != '' ? store.state.user.info.localidades : null;
  }

  // Seção (novos e antigos padrões)
  if ('in_id_secao' in params && !params.in_id_secao) {
    params.in_id_secao = store.state.user.info.secoes !== '' ? store.state.user.info.secoes : null;
  }

  if ('in_id_secoes' in params && !params.in_id_secoes) {
    params.in_id_secoes = store.state.user.info.secoes;
    params.in_id_secoes = store.state.user.info.secoes != '' ? store.state.user.info.secoes : null;
  }

  if ('in_ids_secao' in params && !params.in_ids_secao) {
    params.in_ids_secao = store.state.user.info.secoes;
    params.in_ids_secao = store.state.user.info.secoes != '' ? store.state.user.info.secoes : null;
  }

  return api.post(`api/proc/${locale}/${procedure}`, params);
}

function getMinceturReport(locale, procedure, params) {
  if ('in_id_empresa' in params && !params.in_id_empresa) {
    params.in_id_empresa = store.state.user.info.id_empresa;
  }

  if ('in_ids_empresa' in params && !params.in_ids_empresa) {
    params.in_ids_empresa = store.state.user.info.id_empresa;
  }

  if ('in_id_localidades' in params && !params.in_id_localidades) {
    params.in_id_localidades = store.state.user.info.localidades != '' ? store.state.user.info.localidades : null;
  }

  if ('in_ids_localidade' in params && !params.in_ids_localidade) {
    params.in_ids_localidade = store.state.user.info.localidades != '' ? store.state.user.info.localidades : null;
  }

  if ('in_id_secoes' in params && !params.in_id_secoes) {
    params.in_id_secoes = store.state.user.info.secoes;
    params.in_id_secoes = store.state.user.info.secoes != '' ? store.state.user.info.secoes : null;
  }

  if ('in_ids_secao' in params && !params.in_ids_secao) {
    params.in_ids_secao = store.state.user.info.secoes;
    params.in_ids_secao = store.state.user.info.secoes != '' ? store.state.user.info.secoes : null;
  }

  return api.post(`api/proc/${locale}/${procedure}/mincetur`, params);
}

function activePlayers(groupBy, params) {
  if (!['mes', 'site'].includes(groupBy)) {
    return Promise.reject(new Error('Parametros inválidos'));
  }
  return api.post(`api/proc/report/monitor_operacional_clientes_ativos_por_${groupBy}`, params);
}

function activePlayersWithDeposits(groupBy, params) {
  if (!['default', 'site'].includes(groupBy)) {
    return Promise.reject(new Error('Parametros inválidos'));
  }
  const procSuffix = groupBy === 'site' ? '_por_site' : '';
  return api.post(`api/proc/report/monitor_operacional_clientes_ativos_depositos${procSuffix}`, params);
}

function signUps(groupBy, params) {
  if (!['default', 'site', 'referencia'].includes(groupBy)) {
    return Promise.reject(new Error('Parametros inválidos'));
  }
  const groupByToSuffix = {
    default: '_v2',
    site: '_por_site',
    referencia: '_por_referencia'
  };
  const procSuffix = groupByToSuffix[groupBy];
  return api.post(`api/proc/report/monitor_operacional_registros${procSuffix}`, params);
}

// Relatórios > Sites > Financeiro
function getBonus(groupBy, params) {
  if (!['default', 'site', 'pontoDeVenda', 'cliente', 'campanha', 'referencia'].includes(groupBy)) {
    return Promise.reject(new Error('Parametros inválidos'));
  }
  const groupByToSuffix = {
    default: '',
    site: '_por_site',
    pontoDeVenda: '_por_ponto_de_venda',
    cliente: '_por_cliente',
    campanha: '_por_campanha',
    referencia: '_por_referencia'
  };
  const procSuffix = groupByToSuffix[groupBy];
  return api.post(`api/proc/report/monitor_financeiro_bonus${procSuffix}`, params);
}
function getPromocoesHabilitadas(params) {
  return api.search('business/usuario/promocoesHabilitadas', params);
}
function inserirAcerto(params) {
  return api.post('api/business/registrar/lancamento', params);
}
function estornarLancamento(params) {
  return api.post('api/business/registrar/estorno', params);
}
function aprovarAgendamentoDespesa(params) {
  return api.post('api/business/aprovar/agendamentoDespesa', params);
}
function getResgates(groupBy, params) {
  if (!['default', 'site', 'pontoDeVenda', 'cliente', 'referencia'].includes(groupBy)) {
    return Promise.reject(new Error('Parametros inválidos'));
  }
  const groupByToSuffix = {
    default: '',
    site: '_por_site',
    pontoDeVenda: '_por_ponto_de_venda',
    cliente: '_por_cliente',
    referencia: '_por_referencia'
  };
  const procSuffix = groupByToSuffix[groupBy];
  return api.post(`api/proc/report/monitor_financeiro_resgates${procSuffix}`, params);
}
function getDepositos(groupBy, params) {
  if (!['default', 'site', 'pontoDeVenda', 'cliente', 'referencia', 'campanha'].includes(groupBy)) {
    return Promise.reject(new Error('Parametros inválidos'));
  }
  const groupByToSuffix = {
    default: '',
    site: '_por_site',
    pontoDeVenda: '_por_ponto_de_venda',
    cliente: '_por_cliente',
    referencia: '_por_referencia',
    campanha: '_por_campanha'
  };
  const procSuffix = groupByToSuffix[groupBy];
  return api.post(`api/proc/report/monitor_financeiro_depositos${procSuffix}`, params);
}

function getMovimentos(procName, params) {
  return api.post(`api/proc/report/movimento${procName}`, params);
}

function getRelatoriosPin(params) {
  return api.post(`api/proc/report/saque_pin_parceiro`, params);
}

function getRelatorioEvolucaoPontos(params) {
  return api.post(`api/proc/report/evolucao_de_pontos`, params);
}

function getRelatorioEvolucaoVendas(params) {
  return api.post(`api/proc/report/evolucao_de_vendas`, params);
}

function getRelatorioExtratoComSaldo(params, suffix) {
  return api.post(`api/proc/report/extrato_com_saldo${suffix ? '_' + suffix : ''}`, params);
}

// utils
function getEstados(params) {
  return api.search('common/list/estado', params);
}

function getStatusSaque(params) {
  return api.search('common/list/status_solicitacao_saque', params);
}

function getCidades(params) {
  return api.search('common/list/cidade', params);
}

function getPaises(params) {
  return api.search('common/list/paises', params);
}

function getTiposEsporte(params) {
  return api.search('common/list/tipo_esporte', params);
}

function getModeloImpressora(params) {
  return api.search('common/list/modelo_impressora', params);
}

function getSubEventos(params) {
  return api.search('common/list/tipo_subevento', params);
}

function getGrupoEventos(params) {
  return api.search('common/list/grupo_evento', params);
}

function getGerenciaGrupoEventos(params) {
  return api.search('common/list/gerencia_grupo_evento', params);
}

function getEventos(params) {
  return api.search('common/list/evento', params);
}

function getModalidades(params) {
  return api.search('common/list/modalidade', params);
}

function getEmpresas(params) {
  const empresas = store.state.user.info.empresas || null;
  const filterMultiEmpresa = `id in (${
    empresas && !empresas.includes(store.state.user.info.id_empresa)
      ? empresas.concat(`,${store.state.user.info.id_empresa}`)
      : store.state.user.info.empresas
  })`;

  if (params.filter) {
    if (store.state.user.info.multi_empresa) params.filter += ` and ativo is true and ${filterMultiEmpresa} `;
    else params.filter += ` and ativo is true and id = ${store.state.user.info.id_empresa} `;
  } else {
    if (store.state.user.info.multi_empresa) params.filter = ` ativo is true and ${filterMultiEmpresa} `;
    else params.filter = ` ativo is true and id = ${store.state.user.info.id_empresa} `;
  }

  return api.search('common/list/empresa', params);
}

function getEmpresa(id) {
  return api.getById('entity/empresa', id);
}

function getMetodosPagamento(params) {
  return api.search('common/list/metodo_pagamento', params);
}

function getSites(params) {
  return api.search('common/list/site', params);
}

function getProdutos(params) {
  let filter = `business_logic.produtos.id_empresa=${store.state.user.info.id_empresa} `;
  if (params.hasOwnProperty('filter') && params.filter) {
    params.filter = filter + params.filter;
  } else {
    params.filter = filter;
  }
  return api.search('entity/produto', params);
}

function getSumarioUsuario(idUsuario) {
  return api.search(`business/usuario/sumario/${idUsuario}`);
}

function getInfoUsuario(idUsuario) {
  return api.search(`business/usuario/info/${idUsuario}`);
}

function getExtratoUsuario(params) {
  return api.post(`api/business/usuario/extrato`, params);
}

function getSpinsSlot(params) {
  return api.search(
    `common/usuario/slot/spins/${params.idUsuarioSP}?${
      params?.tokenExtrato ? `tokenExtrato=${params.tokenExtrato}` : ''
    }`
  );
}

function getGames(params) {
  return api.get(`api/entity/game/`, params);
}

function getCartoes(params) {
  return api.post('api/business/cartoes', params);
}

function setReleasedCartoes(params) {
  return api.post('api/business/cartoes/liberar', params);
}

function procSaldoUsuarioApostador(params) {
  return api.post('api/proc/business_view/odin_saldo_usuario_apostador', params);
}

function getLimitesUsuario(idUsuario) {
  return api.search(`entity/site/${idUsuario}`);
}

function getSaques(params) {
  return api.search('entity/saque_view', params);
}

function verificateDuplicity(route, params, cb) {
  api
    .search(route, { ...params, limit: 1 })
    .then((res) => {
      if (res.length > 0) {
        cb && cb(true, false, res, null);
      } else {
        cb && cb(false, true, res, null);
      }
    })
    .catch((err) => {
      cb && cb(false, false, null, err);
    });
}

function updateBonusUsuario(params) {
  return api.post(`api/business/usuario/bonus/extender`, params);
}

function getSlotsfiles(params = {}) {
  return api.search(`entity/game/slots/files`, params);
}

function getSlotsfileUrl(params = {}) {
  return api.post(`api/entity/game/slots/fileurl`, params);
}

function releaseDeposit(params) {
  return api.post(`api/business/deposito/liberar/manual`, params);
}

function applyPromo(params) {
  return api.post(`api/business/deposito/promocao/aplicar`, params);
}

function loadFiles(params) {
  return api.post(`api/business/usuario/arquivos/listar`, params);
}

function applyBonus(params) {
  return api.post(`api/business/usuario/bonus/manual`, params);
}

function registrarCancelamento(params) {
  return api.post(`api/business/resultado/cancelar`, params);
}

function registrarResultado(params) {
  return api.post(`api/business/resultado/manual`, params);
}

function getBilhetesDevolucao(params) {
  return api.search('entity/bilhete_devolucao', params);
}

function procApuradoPorEstabelecimento(param) {
  return api.post('api/proc/report/apurado_por_estabelecimento_v3', param);
}

function payWinningTicket(params) {
  return api.post(`api/business/bilhete/pagamento`, params);
}

function payAuthWinningTicket(params) {
  return api.post(`api/business/bilhete/pagamento/autenticacao`, params);
}

function revalidateWinningTicket(id, params) {
  return api.save('entity/pagamento_premio', params, id);
}

function getUsuarioServico(params) {
  return api.search('entity/servico_usuario', params);
}

function getGerenciaGrupoEventoPreferencia(params) {
  return api.search('common/list/gerencia_grupo_evento_preferencia', params);
}

function getCacheEvento(params) {
  return api.search('common/list/cache_evento_full', params);
}

function getComissoes(params) {
  return api.post(`api/business/relatorio/comissoesPorFaixas`, params);
}

function getPermissoesNegocio(idEmpresa) {
  let permissoes = {
    localidades: new Array()
  };
  return permissoes;
}

const atenaList = {
  procApuradoPorEstabelecimento,
  activePlayers,
  activePlayersWithDeposits,
  cancelarBilhete,
  getCommon,
  getEntity,
  postGeneric,
  getLocalidades,
  getRotas,
  getPaises,
  getTiposEsporte,
  getModeloImpressora,
  getSubEventos,
  getGrupoEventos,
  getGerenciaGrupoEventos,
  getEventos,
  getCircular,
  getSecoes,
  getEstabelecimentos,
  getGestores,
  getBilhetesCancelados,
  getCentrosDeCusto,
  getBilhetes,
  fetchGetBilhetes,
  getStatusBilhetes,
  getEventosBilhetes,
  getCanalDeVenda,
  getLogs,
  getLogins,
  procValidarBilhetePendente,
  revalidarBilhete,
  getEmpresas,
  getDepositos,
  getTipoMetodoPagamentos,
  cancelarDeposito,
  getSites,
  getUsuariosSite,
  getMetodosPagamento,
  getEstados,
  getCidades,
  getPermissaoUsuario,
  getReport,
  signUps,
  getProdutos,
  getGames,
  getEmpresa,
  getBonus,
  getPromocoesHabilitadas,
  inserirAcerto,
  estornarLancamento,
  aprovarAgendamentoDespesa,
  getResgates,
  getDetalheTransacaoSlot,
  getStatusSaque,
  getModalidades,
  getMovimentos,
  getSumarioUsuario,
  getInfoUsuario,
  getExtratoUsuario,
  procSaldoUsuarioApostador,
  getLimitesUsuario,
  getSaques,
  verificateDuplicity,
  updateBonusUsuario,
  applyPromo,
  releaseDeposit,
  loadFiles,
  applyBonus,
  getBilhetesDevolucao,
  applyPromo,
  releaseDeposit,
  getBilhetesPremiados,
  registrarCancelamento,
  registrarResultado,
  payWinningTicket,
  payAuthWinningTicket,
  revalidateWinningTicket,
  registrarPausa,
  getUsuarioServico,
  alterarSenha,
  getSlotsfiles,
  getSlotsfileUrl,
  getGerenciaGrupoEventoPreferencia,
  getRelatoriosPin,
  alterarEmpresa,
  getApuradoLocalidade,
  getRelatorioExtratoComSaldo,
  getRelatorioEvolucaoPontos,
  getRelatorioEvolucaoVendas,
  getCacheEvento,
  getColetaArrecadador,
  getCartoes,
  setReleasedCartoes,
  getComissoes,
  getMinceturReport,
  getSpinsSlot
};

Vue.prototype.$atenaList = atenaList;
export default atenaList;
